import { Component, OnInit, Input } from '@angular/core';
import { Platform } from '@angular/cdk/platform';

@Component({
  selector: 'bzg-status-pages',
  templateUrl: './status-pages.component.html',
  styleUrls: ['./status-pages.component.scss']
})
export class BzgStatusPagesComponent implements OnInit {

  @Input() title: string;
  @Input() message: string;
  @Input() image: string;

  constructor(private platform: Platform) { }

  ngOnInit() {
  }

  getImageXlinkHref() {
    return '#' + this.image;
  }

  isIE(){
    return this.platform.TRIDENT;
  }

}
